import { Outlet } from "react-router-dom"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import ScrollToTop from "../../components/ScrollToTop"
import useGetSearchParams from "../../hooks/useGetSearchParams"
import { useEffect } from "react"

const PaymentLayout = () => {

    return (
        <>
            <Header />
            <div className="container__outlet">
                <Outlet />

            </div>
            <Footer />
            <ScrollToTop />
        </>
    )
}

export default PaymentLayout